import { activityFamily, neatActivityTitle, formatClock } from "./weekScheduleGrid";
import {
  DAY_ACTIVITY_SLOTS,
  activeSlotOverrides,
  normalizeSlotOverrides,
  slotClock,
} from "../constants/dayActivities";

export function resolveSlotOverride(activity, overrides) {
  const fam = activityFamily(activity);
  if (/homework/i.test(String(activity || ""))) {
    return {
      family: null,
      hide: false,
      title: neatActivityTitle(activity),
      notes: "",
      replaceContent: false,
      clock: "",
    };
  }
  const all = normalizeSlotOverrides(overrides, DAY_ACTIVITY_SLOTS);
  const row = fam ? all[fam] : null;
  const def = DAY_ACTIVITY_SLOTS.find((s) => s.id === fam);
  const retimed = Boolean(
    row &&
      def &&
      row.mode !== "hide" &&
      ((row.start && row.start !== def.start) || (row.end && row.end !== def.end))
  );
  const clock = retimed ? slotClock(row) : "";
  if (!row) {
    return {
      family: fam,
      hide: false,
      title: neatActivityTitle(activity),
      notes: "",
      replaceContent: false,
      clock: "",
    };
  }
  if (row.mode === "hide") {
    return {
      family: fam,
      hide: true,
      title: neatActivityTitle(activity),
      notes: "",
      replaceContent: false,
      clock: "",
    };
  }
  return {
    family: fam,
    hide: false,
    title: row.title || neatActivityTitle(activity),
    notes: row.notes || "",
    replaceContent: false,
    clock,
  };
}

export function displaySlotContent(original, override) {
  if (override?.replaceContent && override.notes) return override.notes;
  return original;
}

export function applyOverridesToWeekGrid(grid, overrides) {
  const active = activeSlotOverrides(overrides, DAY_ACTIVITY_SLOTS, true);
  if (!Object.keys(active).length) return grid;
  const columns = (grid.columns || [])
    .filter((col) => {
      const fam = String(col.id || "").split("#")[0];
      if (active[fam]?.mode === "hide") return false;
      return true;
    })
    .map((col) => {
      const fam = String(col.id || "").split("#")[0];
      const row = active[fam];
      const def = DAY_ACTIVITY_SLOTS.find((s) => s.id === fam);
      const title = row?.title || col.activity;
      const retimed = Boolean(
        row && def && ((row.start && row.start !== def.start) || (row.end && row.end !== def.end))
      );
      const time = formatClock(retimed ? slotClock(row) : col.time);
      return {
        ...col,
        activity: title || col.activity,
        time,
        header: time ? `${time}\n${title || col.activity}` : (title || col.activity),
      };
    });
  const extras = Object.entries(active)
    .filter(([, row]) => row.mode === "add")
    .map(([id, row]) => {
      const title = row.title || "New activity";
      const clock = slotClock(row);
      const time = clock ? formatClock(clock) : "";
      return {
        id: `add#${id}`,
        activity: title,
        time,
        header: time ? `${time}\n${title}` : title,
        notes: row.notes || "",
        added: true,
      };
    });
  return { ...grid, columns: [...columns, ...extras] };
}
